import React from "react";
import './imagePopup.scss';
import {Slide} from 'react-slideshow-image'
import art1 from '../../images/image-product-1.jpg'
import art1Th from '../../images/image-product-1-thumbnail.jpg';
import art2Th from '../../images/image-product-2-thumbnail.jpg';
import art3Th from '../../images/image-product-3-thumbnail.jpg';
import art4Th from '../../images/image-product-4-thumbnail.jpg';
import art2 from '../../images/image-product-2.jpg';
import art3 from '../../images/image-product-3.jpg';
import art4 from '../../images/image-product-4.jpg';
import {Fs} from './fs'
import {useState} from "react";
import { AiOutlineClose } from 'react-icons/ai';


export function ImagePopup(props) {
    const hoverHandler = (image, i) => {
        setImg(image)
    }
    const images = [
        art1,
        art2,
        art3,
        art4
    ];
    const [img, setImg] = useState(images[0]);
    function toogle() {
        let blur = document.getElementById('blur');
        blur.classList.remove('active')
    }

    return(props.trigger) ? (
        <div className="containers" >
            <div className="popupImg">
                <button onClick={function() {

                    props.setTrigger(false);
                    toogle();
                }} className="btn-close-popupImg"><AiOutlineClose /></button>

                <img src={img} alt="img" className="popup-img"/>
                <div className="img-grid" >
                    {images.map((image, i) => (
                        <img src={image} alt="" key={i} onMouseOver={() => hoverHandler(image, i)} />
                    ))}
                </div>
            </div>
        </div>



    ) : ""
}






























